import React, { Suspense, useEffect, useRef, useState } from "react";
import { useLocation, useOutletContext } from "react-router-dom";
import { useTranslation } from "react-i18next";
// import ScheduledMeeting from "./ScheduledMeeting";
import { useHeaderTitle } from "../../../context/HeaderTitleContext";
import DraftMeetings from "./DraftMeetings";
import { useMeetings } from "../../../context/MeetingsContext";
import { useTabs } from "../../../context/TabContext";
import SignIn from "../AuthModal/SignIn";
import SignUp from "../AuthModal/SignUp";
import ForgotPassword from "../AuthModal/ForgotPassword";
import NewMeetingModal from "./CreateNewMeeting/NewMeetingModal";
import { useFormContext } from "../../../context/CreateMeetingContext";
import { useSteps } from "../../../context/Step";
import MeetingSubTab from "./MeetingSubTab";
import ReactBigCalendar from "./ReactBigCalendar";
import QuickMomentForm from "../Invities/DestinationToMeeting/QuickMomentForm";
import { formatDate, formatTime } from "./GetMeeting/Helpers/functionHelper";
import { Views } from "react-big-calendar";
import axios from "axios";
import { API_BASE_URL } from "../../Apicongfig";
import moment from "moment";

function MeetingTabs() {
  const {
    updateSolutionSteps,
    setSolutionType,
    setSolutionAlarm,
    setSolutionNote,
    setSolutionFeedback,
    setSolutionShareBy,
  } = useSteps();
  const { resetHeaderTitle } = useHeaderTitle();

  React.useEffect(() => {
    resetHeaderTitle();
  }, []);
  const { open, handleShow, handleCloseModal,setFormState } = useFormContext();
  const location = useLocation();
  const [t] = useTranslation("global");
  const { searchTerm, setSearchTerm } = useOutletContext();
  const userId = parseInt(sessionStorage.getItem("user_id"));

  const queryParams = new URLSearchParams(location.search);
  const fromPresentation2 = queryParams.get("from") === "presentation";
  const fromPresentation3 = queryParams.get("from") === "completeedit";
  const [showMomentForm, setShowMomentForm] = useState(false);

  const lastUrl = localStorage.getItem("lastURL");
  const {
    allDraftMeetings,
    activeMeetingCount,
    closedMeetingCount,
    draftMeetingCount,
    getDraftMeetings,
    getMeetings,
    getClosedMeetings,
    agendaCount,
    getCombineMeetings
  } = useMeetings();

  const [draftMeetings, setDraftMeetings] = useState(allDraftMeetings);

  useEffect(() => {
    let draftMeetings = allDraftMeetings?.filter(
      (meeting) => meeting.status === "draft"
    );
    if (searchTerm) {
      draftMeetings = draftMeetings?.filter(
        (meeting) =>
          meeting?.title?.toLowerCase().includes(searchTerm.toLowerCase()) ||
          meeting?.objective?.toLowerCase().includes(searchTerm.toLowerCase())
      );
    }
    setDraftMeetings(draftMeetings);
  }, [allDraftMeetings, userId, searchTerm]);
  useEffect(() => {
    updateSolutionSteps([]);
    setSolutionType(null);
    setSolutionAlarm(false);
    setSolutionNote("Manual");
    setSolutionFeedback(false);
    setSolutionShareBy(null);
    setActiveTab("tab1");
    
    // if (fromPresentation2) {
    //   setActiveTab("tab3");
    // }
    // if (fromPresentation3) {
    //   setActiveTab("Evènements terminés");
    // }
    // if (lastUrl === "/play") {
    //   setActiveTab("tab3");
    //   localStorage.removeItem("lastURL");
    // }
    getDraftMeetings();
    getMeetings();
    getClosedMeetings();
  }, []);
  const { activeTab, setActiveTab } = useTabs();

  const tabsRef = useRef(null);
  const [isSticky, setIsSticky] = useState(false);
  // const [activeTab, setActiveTab] = useState("tab2");

  const [showSignIn, setShowSignIn] = useState(false);
  const [showSignUp, setShowSignUp] = useState(false);
  const [showForgot, setShowForgot] = useState(false);

  const handleShowSignIn = () => {
    setShowSignUp(false);
    setShowSignIn(true);
  };

  const handleShowSignUp = () => {
    setShowSignIn(false);
    setShowSignUp(true);
  };

  const handleShowForgot = () => {
    setShowSignIn(false);
    setShowSignUp(false);
    setShowForgot(true);
  };

  const handleCloseSignIn = () => setShowSignIn(false);
  const handleCloseSignUp = () => setShowSignUp(false);
  const handleCloseForgot = () => setShowForgot(false);



  const formatDateForApi = (date) => {
    return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(
      2,
      "0"
    )}-${String(date.getDate()).padStart(2, "0")}`;
  };
  const [selectedEvent, setSelectedEvent] = useState(null);
  const [min, setMin] = useState(null);
  const [max, setMax] = useState(null);

  useEffect(() => {
    const currentDate = new Date();
    const startOfWeek = new Date(currentDate);
    startOfWeek.setDate(currentDate.getDate() - currentDate.getDay());
    startOfWeek.setHours(0, 0, 0, 0);

    const endOfWeek = new Date(currentDate);
    endOfWeek.setDate(currentDate.getDate() - currentDate.getDay() + 6);
    endOfWeek.setHours(23, 59, 59, 999);

    setMin(startOfWeek);
    setMax(endOfWeek);
  }, []);
  const {
    setOffset,
    setAgendaEventOffset,
    selectedAgenda,
    setSelectedAgenda,
    setAgendaCount,
  } = useMeetings();
  const [earliestHour, setEarliestHour] = useState(9);
  const [latestHour, setLatestHour] = useState(17);
  const [myEventsList, setMyEventsList] = useState([]);
  const [overlappingSlots, setOverlappingSlots] = useState(new Set());
  const [currentStartDate, setCurrentStartDate] = useState(
    moment().startOf("week").toDate()
  );
  const [currentView, setCurrentView] = useState(Views.WEEK); // Track current view

  const transformMeetingToEvent = (meeting) => {
    if (
      ![
        "active",
        "closed",
        "abort",
        "in_progress",
        "to_finish",
        "todo",
      ].includes(meeting.status)
    )
      return null;

    let start, end;

    const userTimezone = moment.tz.guess();
    const meetingTimezone = meeting?.timezone || "UTC";
    if (meeting.status === "abort") {
      start = moment
        .tz(
          `${meeting?.date} ${meeting?.starts_at}`,
          "YYYY-MM-DD HH:mm:ss",
          meetingTimezone
        )
        .tz(userTimezone)
        .toDate();
      end = getFormattedAbortDateTime(
        meeting?.abort_end_time,
        meeting?.timezone
      );
    } else if (
      meeting.status === "closed" ||
      meeting.status === "in_progress" ||
      meeting?.status === "to_finish" ||
      meeting?.status === "todo"
    ) {
      start = moment
        .tz(
          `${meeting?.date} ${meeting?.starts_at}`,
          "YYYY-MM-DD HH:mm:ss",
          meetingTimezone
        )
        .tz(userTimezone)
        .toDate();

      const estimateDate =
        meeting.estimate_time?.split("T")[0] ||
        meeting.estimate_time?.split(" ")[0];
      const estimateTime =
        meeting.estimate_time?.split("T")[1] ||
        meeting.estimate_time?.split(" ")[1] ||
        "00:00:00";
      end = moment
        .tz(
          `${estimateDate} ${estimateTime}`,
          "YYYY-MM-DD HH:mm:ss",
          meetingTimezone
        )
        .tz(userTimezone)
        .toDate();
    } else {
      start = moment
        .tz(
          `${meeting?.date} ${meeting?.start_time}`,
          "YYYY-MM-DD HH:mm:ss",
          meetingTimezone
        )
        .tz(userTimezone)
        .toDate();
      const estimateDate =
        meeting.estimate_time?.split("T")[0] ||
        meeting.estimate_time?.split(" ")[0];
      const estimateTime =
        meeting.estimate_time?.split("T")[1] ||
        meeting.estimate_time?.split(" ")[1] ||
        "00:00:00";
      end = moment
        .tz(
          `${estimateDate} ${estimateTime}`,
          "YYYY-MM-DD HH:mm:ss",
          meetingTimezone
        )
        .tz(userTimezone)
        .toDate();
    }

    return {
      id: meeting.id,
      title: meeting.title,
      start: start,
      end: end,
      allDay: false,
      resource: meeting,
      steps: meeting?.steps,
    };
  };
  const getFormattedAbortDateTime = (abortDateTime, timezone) => {
    const userTimezone = moment.tz.guess();
    return moment
      .tz(abortDateTime, "YYYY-MM-DD HH:mm:ss", timezone || "UTC")
      .tz(userTimezone)
      .toDate();
  };
  const getOverlappingSlots = (events, step = 15) => {
    const overlaps = new Set();

    for (let i = 0; i < events.length; i++) {
      for (let j = i + 1; j < events.length; j++) {
        const e1 = events[i];
        const e2 = events[j];

        const start1 = moment(e1.start);
        const end1 = moment(e1.end);
        const start2 = moment(e2.start);
        const end2 = moment(e2.end);

        if (start1.isBefore(end2) && start2.isBefore(end1)) {
          const overlapStart = moment.max(start1, start2).startOf("minute");
          const overlapEnd = moment.min(end1, end2).startOf("minute");

          let current = overlapStart.clone();
          while (current < overlapEnd) {
            overlaps.add(current.format("HH:mm"));
            current.add(step, "minutes");
          }
        }
      }
    }

    return overlaps;
  };
  const getCompletedMeetings = async (startDate) => {
    let response;
    const currentTime = new Date();
    const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

    const options = { timeZone: userTimeZone };
    const timeInUserZone = new Date(
      currentTime.toLocaleString("en-US", options)
    );

    const formattedTime = formatTime(timeInUserZone);
    const formattedDate = formatDate(timeInUserZone);

    try {
      const start = new Date(startDate);
      const end = new Date(start);

      // Adjust date range based on current view
      if (currentView === Views.WEEK) {
        end.setDate(start.getDate() + 7);
      } else if (currentView === Views.MONTH) {
        end.setMonth(start.getMonth() + 1);
      }

      const startDateStr = formatDateForApi(start);
      const endDateStr = formatDateForApi(end);

      if (selectedAgenda?.tektime && selectedAgenda?.google) {
        response = await axios.get(
          `${API_BASE_URL}/get-all-meetings/tektime-google-agenda?current_time=${formattedTime}&current_date=${formattedDate}&timezone=${userTimeZone}&m_start_date_filter=${startDateStr}&m_end_date_filter=${endDateStr}&sync_agenda=${true}`,
          {
            headers: {
              Authorization: `Bearer ${sessionStorage.getItem("token")}`,
            },
          }
        );
      } else if (selectedAgenda?.tektime) {
        response = await axios.get(
          `${API_BASE_URL}/get-all-meetings/tektime-agenda?current_time=${formattedTime}&current_date=${formattedDate}&timezone=${userTimeZone}&m_start_date_filter=${startDateStr}&m_end_date_filter=${endDateStr}&sync_agenda=${true}`,
          {
            headers: {
              Authorization: `Bearer ${sessionStorage.getItem("token")}`,
            },
          }
        );
      } else if (selectedAgenda?.google) {
        response = await axios.get(
          `${API_BASE_URL}/get-all-meetings/google-agenda?current_time=${formattedTime}&current_date=${formattedDate}&timezone=${userTimeZone}&m_start_date_filter=${startDateStr}&m_end_date_filter=${endDateStr}&sync_agenda=${true}`,
          {
            headers: {
              Authorization: `Bearer ${sessionStorage.getItem("token")}`,
            },
          }
        );
      }

      if (response?.status === 200) {
        const meetings = response?.data?.meetings || response?.data?.data || [];
        const transformedMeetings = meetings.map((meeting) => {
          const transformedMeeting = transformMeetingToEvent(meeting);
          return transformedMeeting;
        });
        const filteredMeetings = transformedMeetings.filter(
          (meeting) => meeting !== null
        );

        const sortedMeetings = filteredMeetings.sort(
          (a, b) => new Date(a.start) - new Date(b.start)
        );

        if (sortedMeetings.length > 0 && currentView === Views.WEEK) {
          const earliestMeeting = sortedMeetings[0];
          const latestMeeting = sortedMeetings[sortedMeetings.length - 1];

          const minTime = new Date(earliestMeeting.start);
          const maxTime = new Date(latestMeeting.end);
          setMin(minTime);
          setMax(maxTime);
        }

        if (filteredMeetings.length > 0 && currentView === Views.WEEK) {
          let earliestHr = 24;
          let latestHr = 0;

          const weekStart = new Date(startDate);
          const weekEnd = new Date(weekStart);
          weekEnd.setDate(weekStart.getDate() + 7);

          filteredMeetings.forEach((meeting) => {
            const start = new Date(meeting.start);
            const end = new Date(meeting.end);

            if (
              start >= weekStart &&
              end <= weekEnd &&
              start.toDateString() === end.toDateString()
            ) {
              const startHour = start.getHours();
              const endHour = end.getHours();

              earliestHr = Math.min(earliestHr, startHour);
              latestHr = Math.max(latestHr, endHour);
            }
          });

          if (earliestHr !== 24) setEarliestHour(earliestHr);
          if (latestHr !== 0) setLatestHour(latestHr);
        }

        setOverlappingSlots(getOverlappingSlots(filteredMeetings, 15));
        setAgendaCount(filteredMeetings.length);
        setMyEventsList(filteredMeetings);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
    }
  };


  const refresh = async()=>{
    getCompletedMeetings(currentStartDate);
    getCombineMeetings(false)
  }
  


  return (
    <>
      <div className="tabs-container container-fluid">
        <div
          ref={tabsRef}
          className={`tabs-header ${isSticky ? "sticky" : ""}`}
        >
             <div className="d-flex align-items-center justify-content-between">
          <h4 className="">{t("meeting.title")}</h4>


        <button
                  className={`btn moment-btn`}
                  onClick={()=>{
                    window.open('https://calendly.com/tektime/tektime-qu-est-ce-que-c-est ',"_blank")
                  }}
                >
                  {t("request a demo")}
                </button>
        </div>
          <small style={{ padding: "15px 14px" }}>
            {t(
              "A moment is a professional activity put in place to achieve the desired end result."
            )}
          </small>

          <div className={`container-fluid ${isSticky ? "" : "py-1 px-3"}`}>
            <div
              className="row align-items-center gutter-0"
              style={{ padding: "0 10px" }}
            >
              {/* Tabs Section */}
              <div
                className="col-lg-8 col-md-8 col-12 border-bottom tabs-meeting"
                style={{ borderBottom: "2px solid #F2F2F2" }}
              >
                <div className="tabs" style={{ overflowX: "auto" }}>
                  <div className="d-flex">
                    <button
                      className={`tab ${activeTab === "tab1" ? "active" : ""}`}
                      onClick={() => setActiveTab("tab1")}
                    >
                      {t("meeting.agenda")}
                      <span
                        className={activeTab === "tab1" ? "future" : "draft"}
                      >
                        {agendaCount}
                      </span>
                    </button>
                    <button
                      className={`tab ${activeTab === "tab2" ? "active" : ""}`}
                      onClick={() => setActiveTab("tab2")}
                    >
                      {t("meeting.list")}
                      <span
                        className={activeTab === "tab2" ? "future" : "draft"}
                      >
                        {activeMeetingCount + closedMeetingCount}
                      </span>
                    </button>
                    <button
                      className={`tab ${activeTab === "tab3" ? "active" : ""}`}
                      onClick={() => setActiveTab("tab3")}
                    >
                      {t("meeting.draftTab")}
                      <span
                        className={activeTab === "tab3" ? "future" : "draft"}
                      >
                        {draftMeetingCount}
                      </span>
                    </button>
                  </div>
                </div>
              </div>
              {/* Button Section */}
              <div
                className={`col-lg-4 col-md-4 col-12 gap-2 d-flex  ${
                  isSticky ? "sticky-button" : "justify-content-end p-0"
                }`}
              >
                <button
                  className={`btn moment-btn d-flex`}
                  onClick={()=>{
                   setFormState({
       selectedOption: null,
    title: null,
    date: null,
    start_time: null,
    description: null,
    type: null,
    priority: null,
    alarm: false,
    feedback: false,
    remainder: false,
    autostart: false,
    playback: "Manual",
    prise_de_notes: "Manual",
    note_taker: false,
    objective: null,
    casting_type: "Invitation",
    participants: [],
    id: null,
    repetition: false,
    repetition_number: 1,
    repetition_frequency: "Daily",
    repetition_end_date: null,
    selected_days: [],
    teams: [],
    steps:[],
    moment_privacy: "participant only",
    moment_privacy_teams: [],
    moment_password: null,
    location: null,
    agenda: null,
    address:null,
    room_details: null,
    phone: null,
    share_by: null,
    price: null,
    max_participants_register: 0,
    casting_tab: null,
    solution_id:null,
    solution_tab: "use a template",
    client: null,
client_id: null,
destination: null,
destination_id: null,
destination_type: null,
    })
                    handleShow();

                  }}
                >
                  <span>
                    <svg
                      width="16"
                      height="16"
                      viewBox="0 0 16 16"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M8 14.75V1.25M1.25 8H14.75"
                        stroke="white"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </span>
                  &nbsp;{t("meeting.buttons.create")}
                </button>
                <button
                  className={`btn moment-btn d-flex`}
                  onClick={()=>setShowMomentForm(true)}
                >
                  <span>
                    <svg
                      width="16"
                      height="16"
                      viewBox="0 0 16 16"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M8 14.75V1.25M1.25 8H14.75"
                        stroke="white"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </span>
                  &nbsp;                            {t("addQuickMomentbtninmission")}

                </button>
              </div>
            </div>
          </div>
          {/* SignIn Modal */}
          <SignIn
            show={showSignIn}
            handleClose={handleCloseSignIn}
            handleShowSignUp={handleShowSignUp}
            handleShowForgot={handleShowForgot}
          />

          {/* SignUp Modal */}
          <SignUp
            show={showSignUp}
            handleClose={handleCloseSignUp}
            handleShowSignIn={handleShowSignIn}
          />
          {/* Forgot Password Modal */}
          <ForgotPassword
            show={showForgot}
            handleClose={handleCloseForgot}
            handleShowForgot={handleShowForgot}
          />
        </div>
        <div className="content">
          {activeTab === "tab1" && (
            <div>
            
              <ReactBigCalendar activeTab={activeTab} />
            </div>
          )}
          {activeTab === "tab2" && (
            <div>
              <MeetingSubTab />
            </div>
          )}
          {activeTab === "tab3" && (
            <div>
              <DraftMeetings
                allMeetings={draftMeetings}
                activeTab={activeTab}
              />
            </div>
          )}
        </div>
        {open && (
          <>
            <NewMeetingModal open={open} closeModal={handleCloseModal} openedFrom="moment" />
          </>
        )}

          {showMomentForm && (
                    <QuickMomentForm
          show={showMomentForm}
          onClose={() => {setShowMomentForm(false); 
             setFormState({
      selectedOption: null,
      title: "",
      date: "",
      start_time: "",
      description: "",
      type: "",
      priority: "",
      alarm: false,
      feedback: false,
      remainder: false,
      notification:false,
      autostart: false,
      playback: "Manual",
      prise_de_notes: "Manual",
      note_taker: false,
      objective: "",
      participants: [],
    steps:[],
        solution_tab: "use a template",
        solution_id:null,
      id: null,
      repetition: false,
      repetition_number: 1,
      repetition_frequency: "Daily",
      repetition_end_date: null,
      selected_days: [],
      teams: [],
      moment_privacy: "participant only",
      moment_privacy_teams: [],
      moment_password: null,
      location: null,
      agenda: null,
      address:null,
      room_details: null,
      phone: null,
      share_by: null,
      price: null,
                max_participants_register: 0,

      casting_tab: null,
    });
          }}
          openedFrom="meeting"
          destination={null}
          refresh={refresh}
        />)}
      </div>
    </>
  );
}

export default MeetingTabs;
